<template>
  <div>
    <b-row class="toolbar-ptc">
      <b-col></b-col>
      <b-col class="text-center title">情報分析 / 支付使用數據統計</b-col>
      <b-col>
        <div class="text-right">
          <b-btn class="btn btn-ptc1" v-b-toggle.collapse1>查詢</b-btn>
        </div>
      </b-col>
    </b-row>

    <div id="func-content">
      <b-collapse id="collapse1" class="mt-2" style="margin-bottom: 10px;">
        <b-card class="bg-default-card">
          <div class="row">
            <div class="col-lg-12">
              <div class="p-4 box-shadow">
                <div class="row">
                    <div class="row col-md-12">
                      <label class="control-label col-md-2 mt-2 text-right">日期：</label>
                      <div class="col-md-3">
                        <input type="date" class="form-control" v-model="search.sdate">
                      </div>
                      <label class="mt-2">至</label>
                      <div class="col-md-3">
                        <input type="date" class="form-control" v-model="search.edate">
                      </div>
                    </div>
                    <div class="row col-md-12">
                      <label class="control-label col-md-2 mt-2 text-right">支付工具：</label>
                      <div class="col-md-3">
                        <select id="payment" name="payment" class="form-control" v-model="search.payment">
                          <option v-bind:value="0" :key="0">全部</option>
                          <option v-for="x in paymenttypeList" v-bind:value="x.ID" :key="x.ID">{{x.Text}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="row col-md-12">
                      <label class="control-label col-md-2 mt-2 text-right">會員分類：</label>
                      <div class="col-md-3">
                        <select class="form-control" id="membergradeid" name="membergradeid" v-model="search.membergradeid">
                          <option v-bind:value="0" :key="0">全部</option>
                          <option v-bind:value="10" :key="10">基本會員</option>
                          <option v-bind:value="20" :key="20">正式會員</option>
                        </select>
                      </div>
                      <label class="control-label col-md-2 mt-2 text-right">會員年齡：</label>
                      <div class="col-md-3">
                        <select class="form-control" id="age" name="age" v-model="search.age">
                          <option v-bind:value="-1" :key="-1">全部</option>
                          <option v-bind:value="0" :key="0">0~9</option>
                          <option v-bind:value="1" :key="1">10~19</option>
                          <option v-bind:value="2" :key="2">20~29</option>
                          <option v-bind:value="3" :key="3">30~39</option>
                          <option v-bind:value="4" :key="4">40~49</option>
                          <option v-bind:value="5" :key="5">50~59</option>
                          <option v-bind:value="6" :key="6">60~69</option>
                          <option v-bind:value="7" :key="7">70~79</option>
                          <option v-bind:value="8" :key="8">80歲以上</option>
                        </select>
                      </div>
                    </div>
                    <div class="row col-md-12">
                      <label class="control-label col-md-2 mt-2 text-right">會員性別：</label>
                      <div class="col-md-3">
                        <select class="form-control" id="membergender" name="membergender" v-model="search.membergender">
                          <option v-bind:value="''" :key="''">全部</option>
                          <option v-bind:value="'male'" :key="'male'">男</option>
                          <option v-bind:value="'female'" :key="'female'">女</option>
                          <option v-bind:value="'private'" :key="'private'">不公開</option>
                        </select>
                      </div>
                      <label class="control-label col-md-2 mt-2 text-right">地區：</label>
                      <div class="col-md-3">
                        <select class="form-control" id="city" name="city" v-model="search.city">
                          <option v-bind:value="''" :key="''">全部</option>
                          <option v-for="x in citylist" v-bind:value="x.City" :key="x.City">{{x.City}}</option>
                        </select>
                      </div>
                      <div class="col-lg-2">
                          <button type="button" class="btn btn-warning text-white" @click="getinformationpayforuse(1)">查詢</button>
                      </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </b-card>
      </b-collapse>
      <b-card class="bg-default-card" v-if="Plist.length>0">
        <div class="row" style="height: 280px">
          <div class="col-lg-4">
            <table id="mytable" class="table table-bordred table-striped">
              <thead>
                <tr>
                  <th>支付項目</th>
                  <th>交易筆數</th>
                </tr>
              </thead>
              <tbody>
                <tr  v-for="x in pieitems" :key="x.name">
                  <td>{{x.name}}</td>
                  <td>{{x.value}}</td>
                </tr>
                <!-- <tr>
                  <td>使用張數</td>
                  <td>{{used_coupon}}</td>
                </tr>
                <tr>
                  <td>失效張數</td>
                  <td>{{invalid_coupon}}</td>
                </tr>
                <tr>
                  <td>未使用張數</td>
                  <td>{{not_used_coupon}}</td>
                </tr>
                <tr>
                  <td>總兌換張數</td>
                  <td>{{total_coupon}}</td>
                </tr> -->
              </tbody>
            </table>
          </div>
          <div class="col-lg-8">
            <IEcharts :option="pie" :loading="loading" @ready="onReady"></IEcharts>
          </div>
        </div>
      </b-card>
      <b-card class="bg-default-card">
        <div class="row">
          <div class="col-lg-12">
            <div class="row">
              <div class="col-lg-6">
                <h3></h3>
              </div>
              <div class="col-lg-12 mt-2">
                <div class="table-responsive">
                  <table class="table table-bordred table-striped">
                    <thead>
                      <tr>
                        <th>支付方式</th>
                        <th>性別</th>
                        <th>年齡</th>
                        <th>交易筆數</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="x in Plist" :key="x.PaymentID">
                        <td>{{x.PaymentName}}</td>
                        <td v-show='x.Gender=="male"'>男</td>
                        <td v-show='x.Gender=="female"'>女</td>
                        <td v-show='x.Gender=="private"'>不公開</td>
                        <td v-show='x.Gender==""'>無</td>
                        <td v-show='x.AGE>=1'>{{x.AGE}}0~{{x.AGE}}9</td>
                        <td v-show='x.AGE<1'>無</td>
                        <td>{{x.Count}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div>
                <div class="row" style="padding: 0 1rem">
                  <b-pagination size="md" :total-rows="search.totalrows" v-model="search.currentPage" :per-page="search.perpage" @change="getinformationpayforuse"></b-pagination>
                  <label style="margin:8px">{{search.startRowNum}}到{{search.endRowNum}}，總共 {{search.totalrows}}筆</label>
                </div>
              </div>
              </div>
            </div>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script src="//cdnjs.cloudflare.com/ajax/libs/vue/2.5.2/vue.min.js"></script>
<script src="//cdn.jsdelivr.net/npm/sortablejs@1.7.0/Sortable.min.js"></script>
<script src="//cdnjs.cloudflare.com/ajax/libs/Vue.Draggable/2.15.0/vuedraggable.min.js"></script>

<script>
import { getFunctionPermission } from "../../../js/LoginUserFunction.js";
import { API_URL } from "../../../store/root";
import miniToastr from "mini-toastr";
import IEcharts from 'vue-echarts-v3/src/full.js'
import draggable from "vuedraggable";
import VModal from "vue-js-modal";
import axios from "axios";
miniToastr.init();
export default {
  components: {
    draggable,
    IEcharts
  },
  data() {
    return {
      search: {
        sdate: "",
        edate: "",
        payment: 0,
        membergradeid: 0,
        age: -1,
        membergender: "",
        city: "",
        currentPage: 1,
        perpage: 20,
        totalrows: 0,
        startRowNum: 0,
        endRowNum: 0,
      },
      Plist:[], // 顯示列表
      citylist: [], // 地區類別下拉
      pieitems: [], // 圖表項目
      instances: [],
      loading: false,
      pie: {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} 筆({d} %)'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          textStyle: {
            fontWeight: 'bold',
            fontSize: 16
          },
          data: []
        },
        series: [{
          name: '交易筆數',
          type: 'pie',
          radius: '50%',
          center: ['70%', '50%'],
          itemStyle: {
            normal: {
              label: {
                textStyle: {
                  fontSize: 18
                }
              }
            },
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 1)'
            }
          },
          data: []
        }]
      },
      paymenttypeList: [], // 付款類型
      API_URL: API_URL,
      selectListPosType: [], // Pos分類下拉選單
      startRowNum: 0,
      endRowNum: 0,
      items: [],
      md_imgUrl: undefined
    };
  },
  created() {
    this.FunctionPermission = getFunctionPermission("F24"); // 功能權限
    if (this.FunctionPermission < 1) {
      this.$router.push({ name: "name" });
      return;
    }
    this.setdate();
    this.getpost();
    this.querySelectListData();
    this.getinformationpayforuse(1);
    var search = this.$route.params.search;
    this.query();
  },
  methods: {
    onReady (instance) {
      this.instances.push(instance)
    },
    btnQuery() {
      this.search.currentPage = 1;
      this.query();
    },
    CheckDateTime(mystring) {
      var reg = /^(\d{4})\-(\d{2})\-(\d{2})$/;
      var str = mystring;
      var arr = reg.exec(str);
      if (str=="") return true;
      if (!reg.test(str)&&RegExp.$2<=12&&RegExp.$3<=31){
        return false;
      }
      return true;
    },
    getpost () {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/marketing/getallstores/v1', {
      })
        .then((response) => {
          if (response.data.result === '0000') {
            this.citylist = response.data.data
            this.$store.commit('TOKEN', response.data.jwt)
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '資料讀取異常')
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          miniToastr.error(error.message, '資料讀取異常')
          this.$parent.Loading = false
        })
    },
    getinformationpayforuse (currentPage) {
      if (this.search.sdate === '' || this.search.edate === '' || this.search.sdate > this.search.edate) {
        miniToastr.error('請選擇正確的效期區間')
        return
      }
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/information/payforuse/v1', {
        sdate: this.search.sdate,
        edate: this.search.edate,
        paymenttype: this.search.payment,
        membergradeid: this.search.membergradeid,
        age: this.search.age,
        membergender:this.search.membergender,
        city:this.search.city,
        toPage: currentPage,
        perPage: this.search.perpage
      })
        .then((response) => {
          if (response.data.result === '0000') {
            this.Plist = [];
            this.pie.legend.data = [];
            this.pie.series[0].data = [];
            this.pieitems = [];
            var responseData = response.data.data;
            var paymentList = [];
            var pielist = [];
            var pietype = [];
            var ptlist = this.paymenttypeList;
            var startRowNum=(response.data.count === undefined || response.data.count === 0) ? 0 : this.search.perpage * (this.search.currentPage - 1) + 1;
            var endRowNum=(response.data.count === undefined || response.data.count === 0) ? 0 : (this.search.perpage > response.data.count) ? response.data.count : (this.search.currentPage * this.search.perpage) >= response.data.count ? response.data.count : this.search.currentPage * this.search.perpage

            if (responseData != null) {
              for (let i = 0; i < responseData.length; i++) {
                const arrRole = responseData[i];
                const resultNum = i + 1; 
                var paymentname = "";
                var paymentname = "";
                var paymentcolor = "";
                ptlist.forEach(function (i,index){
                  if (arrRole.PaymentID == i.ID) {
                    paymentname = i.Text;
                    paymentcolor = i.Color;
                  }
                })
                if (resultNum >= startRowNum && resultNum <= endRowNum) {
                  paymentList.push({
                    PaymentName:paymentname,
                    Gender:arrRole.Gender,
                    AGE:arrRole.AGE,
                    Count:arrRole.Count,
                  });
                }

                var addpie = true;
                pielist.forEach(function (i,index){
                  if (i.name == paymentname) {
                    pielist[index].value += arrRole.Count;
                    addpie = false
                  }
                })
                if (addpie) {
                  pielist.push({value: arrRole.Count, name: paymentname, itemStyle: {normal: {color: paymentcolor}}});
                  pietype.push(paymentname);
                }
              }
              this.Plist = paymentList;
              this.pie.legend.data = pietype;
              this.pie.series[0].data = pielist;
              this.pieitems = pielist;
            }
            this.search.totalrows = (response.data.count === undefined) ? 0 : response.data.count
            this.search.currentPage = currentPage
            this.search.startRowNum = startRowNum
            this.search.endRowNum = endRowNum
            this.$store.commit('TOKEN', response.data.jwt)
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '查詢失敗')
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          miniToastr.error(error.message, '查詢失敗')
          this.$parent.Loading = false
        })
    },
    query() {
      var name, attributesCode, status, appShow, payment, sdate, edate, page, pageRows;
      status = 1;
      payment = this.search.payment;
      pageRows = this.pageRows;
      if (!this.CheckDateTime(this.search.sdate)){
        miniToastr.error("起始日期格式錯誤");
        return
      }
      if (!this.CheckDateTime(this.search.edate)){
        miniToastr.error("結束日期格式錯誤");
        return
      }
      if (this.search.sdate > this.search.edate){
        miniToastr.error("起始月份不可大於結束月份");
        return
      }
      this.$parent.Loading = true;
      return axios
        .post(API_URL + "/web/information/payment/v1", {
          sdate: this.search.sdate,
          edate: this.search.edate,
          store: this.search.store,
          payment: this.search.payment
        })
        .then(response => {
          this.$store.commit("TOKEN", response.data.jwt);
          this.$parent.Loading = false;

          if (response.data.result === "0000") {
            this.items = response.data.data;
          } else if (response.data.result === "0006") {
            this.$parent.logOut(true, true);
          } else {
            this.items = [];
            miniToastr.error(response.data.message, "資料讀取異常");
          }
        })
        .catch(error => {
          this.items = [];
          this.$parent.Loading = false;
          miniToastr.error(error, "資料讀取異常");
        });
    },
    querySelectListData() {
      //支付工具
      axios
        .post(API_URL + "/web/getpayment/v1", {
          status: 0
        })
        .then(response => {
          this.paymenttypeList = response.data.data;
          this.$parent.Loading = false;
        })
        .catch(error => {
          this.selectListPosType = [];
          this.$parent.Loading = false;
          miniToastr.error(error, "資料讀取異常");
        });
    },
    setdate() {
      var d = new Date();
      var year = d.getFullYear();
      var mon =
      d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
      var day =d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
      this.search.edate = year+"-"+mon+"-"+day;
      year = d.getFullYear();
      mon = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
      this.search.sdate = year+"-"+mon+"-01";
    },
    changePage(page) {
      this.search.currentPage = page;
      this.query();
    }
  },
  filters: {
    formatDate: function(date) {
      var d = new Date(date);
      var year = d.getFullYear();
      var mon =
        d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
      var day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
      return year + "/" + mon + "/" + day;
    },
    formatFullDate: function(date) {
      var d = new Date(date);
      var year = d.getFullYear();
      var mon =
        d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
      var day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
      var hour = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
      var min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
      var sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
      return year + "/" + mon + "/" + day + " " + hour + ":" + min + ":" + sec;
    }
  }
};
</script>
<style scoped>
.box-shadow {
  box-shadow: 0px 0px 1px 1px #cfcfcf;
}
.table-move > tbody > tr {
  cursor: move;
}
.block {
  text-align: center;
  height: 454pt;
}
.front_img {
  height: 450pt;
  position: relative;
  z-index: 1;
}
.bk_div {
  top: 53pt;
  left: 79pt;
  width: 196pt;
  height: 344pt;
  position: absolute;
  z-index: 0;
}
.bk_img {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/information/payforuse/List.vue